import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { Menu, MenuModule } from 'primeng/menu';
import { SkeletonModule } from 'primeng/skeleton';

import { AgentSession } from 'src/app/@shared/models/ai/agent-session.model';
import { AvatarComponent } from 'src/app/@shared/components/user/avatar/avatar.component';

/** Liste des conversations récentes (ouvrir / renommer / supprimer remontés au parent). */
@Component({
    selector: 'app-assistant-recent',
    standalone: true,
    imports: [
        CommonModule,
        ButtonModule,
        MenuModule,
        SkeletonModule,
        AvatarComponent,
    ],
    templateUrl: './assistant-recent.component.html',
})
export class AssistantRecentComponent {

    @Input() sessions: AgentSession[] = [];
    @Input() loading: boolean = false;
    @Output() openSession = new EventEmitter<AgentSession>();
    @Output() renameSession = new EventEmitter<AgentSession>();
    @Output() deleteSession = new EventEmitter<AgentSession>();

    menuItems: MenuItem[] = [];
    readonly skeletons: number[] = [0, 1];

    public onClickMenu(event: Event, session: AgentSession, menu: Menu): void {
        this._buildMenu(session);
        menu.toggle(event);
    }

    public onClickOpen(session: AgentSession): void {
        this.openSession.emit(session);
    }

    private _buildMenu(session: AgentSession): void {
        this.menuItems = [
            { label: 'Renommer', icon: 'pi pi-pencil', command: () => this.renameSession.emit(session) },
            { label: 'Supprimer', icon: 'pi pi-trash', iconClass: 'text-red-500', command: () => this.deleteSession.emit(session) },
        ];
    }
}
